// import React, { Component } from 'react';
// import GoogleMapReact from 'google-map-react';

// const AnyReactComponent = ({ text }) => <div>{text}</div>;
// class GoogleMapStyle extends Component {
//   static defaultProps = {
//     center: {
//       lat: 24.3746,
//       lng: 88.6004
//     },
//     zoom: 11
//   };

//   render() {
//     return (
//       // Important! Always set the container height explicitly
//       <div className="google-map-style-1">
//         <GoogleMapReact
//           // bootstrapURLKeys={{ key: /* YOUR KEY HERE */ }}
//           defaultCenter={this.props.center}
//           defaultZoom={this.props.zoom}
//         >
//           <AnyReactComponent
//             lat={24.3746}
//             lng={88.6004}
//             text="My Marker"
//           />
//         </GoogleMapReact>
//       </div>
//     );
//   }
// }

// export default GoogleMapStyle;

import React from 'react';

const GoogleMapStyle = () => {
  return (
    <div className="google-map-style-1" style={{ height: '80%', width: '100%' }}>
      <iframe
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src="https://www.openstreetmap.org/export/embed.html?bbox=88.5954%2C24.3696%2C88.6054%2C24.3796&layer=mapnik&marker=24.3746%2C88.6004"
        title="OpenStreetMap"
      ></iframe>
      <br />
      <small>
        <a href="https://www.openstreetmap.org/?mlat=24.3746&mlon=88.6004#map=15/24.3746/88.6004" target="_blank" rel="noreferrer">
          View Larger Map
        </a>
      </small>
    </div>
  );
};

export default GoogleMapStyle;
